import React from 'react'
import { H4, Span } from '../../lib/components'

const RMContactInfo = () => {
  return (
    <div className='rm-contact-info-container'>
      <div className='rm-contact-info-card'>
        <H4 text='To withdraw, contact your Relationship Manager (RM).' />

        <div className='rm-contact-details'>
          <div className='rm-detail-item'>
            <Span text='Name: ' variant='bold' />
            <Span text='Khushboo Agarwal' />
          </div>

          <div className='rm-detail-item'>
            <Span text='Email: ' variant='bold' />
            <a href='mailto:khushboo.agarwal@credibila.com' className='rm-contact-link'>
              <Span text='khushboo.agarwal@credibila.com' />
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

export { RMContactInfo }
